import { render, staticRenderFns } from "./ServiceRow.vue?vue&type=template&id=3bc85407&scoped=true"
import script from "./ServiceRow.vue?vue&type=script&lang=js"
export * from "./ServiceRow.vue?vue&type=script&lang=js"
import style0 from "./ServiceRow.vue?vue&type=style&index=0&id=3bc85407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc85407",
  null
  
)

export default component.exports